'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgRefresh } from '@common/icon';
import { ROUTES } from '@/constants';
import { useCustomRouter } from '@/hooks/useCustomRouter';
export const EmptyState = () => {
  const $ = _c(6);
  const {
    push
  } = useCustomRouter();
  let t0;
  if ($[0] !== push) {
    t0 = () => {
      push(ROUTES.RECOMMEND_POLICY_LIST.pathname);
    };
    $[0] = push;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const handleReset = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <p className="whitespace-pre-wrap text-center font-400 text-Gray-700 typo-body4">{"\uC870\uAC74\uC5D0 \uB9DE\uB294 \uC815\uCC45\uC774 \uC5C6\uC5B4\uC694\n\uB2E4\uB978 \uC870\uAC74\uC73C\uB85C \uB2E4\uC2DC \uCC3E\uC544\uBCF4\uC138\uC694."}</p>;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SvgRefresh className="size-14" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== handleReset) {
    t3 = <div className="flex min-h-[calc(100vh-330px)] flex-col items-center justify-center gap-16 px-20">{t1}<Button theme="sub-line" dimensions="H40" onClick={handleReset} className="bg-Gray-white">{t2}모든 필터 초기화</Button></div>;
    $[4] = handleReset;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};